import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import { Form, FormActions } from 'components/form';
import ActionButton from 'components/buttons/action-button/ActionButton';
import ProfileFormFieldsChannels from './form/channels/ProfileFormFieldsChannels';
import UnderageLegalWarning from '../legal-warning/UnderageLegalWarning';

import { getExpiredAnalyticsDataForInfluencer } from 'utils/influencers';

import type { ChannelForm, InfluencerProfileForm } from 'types';

import type { FieldDescriptionShowParams } from '../influencer-create-profile/InfluencerCreateProfile';

applyTranslations(require('./i18n/profile-creation-common.i18n.json'));

type Props = {
  details: InfluencerProfileForm,
  hasError: boolean,
  onSubmit: (a: InfluencerProfileForm) => void,
  onCancel: (a: InfluencerProfileForm) => void,
  onFieldDescriptionShow: (p: FieldDescriptionShowParams) => void,
  onFieldDescriptionHide: () => void,
  onValidationErrors: () => void
};

type State = {
  details: InfluencerProfileForm
};

class ProfileCreationStepChannels extends React.PureComponent<Props, State> {
  state = {
    details: {
      ...this.props.details
    }
  };

  handleDetailsChanged = (details: InfluencerProfileForm): void => {
    this.setState(state => ({
      details: {
        ...state.details,
        ...details
      }
    }));
  };

  handleChannelsChanged = (channels: Array<ChannelForm>): void => {
    this.setState(state => ({
      details: {
        ...state.details,
        channels
      }
    }));
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { details } = this.state;

    onSubmit(details);
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    const { details } = this.state;

    onCancel(details);
  };

  renderAgeWarning(): React.ReactNode {
    const { details } = this.state;

    return <UnderageLegalWarning dateOfBirth={details.influencerDateOfBirth} />;
  }

  render() {
    const { hasError, onValidationErrors, onFieldDescriptionShow, onFieldDescriptionHide } = this.props;
    const { details } = this.state;

    return (
      <section
        className="influencer-create-profile__form-container"
        data-qa="profile-creation-step-channels"
      >
        <Form
          className="influencer-create-profile__form-container-inner-block"
          onSubmit={this.handleSubmit}
          onValidationErrors={onValidationErrors}
        >
          <ProfileFormFieldsChannels
            channels={details.channels}
            isCreationStep
            hasError={hasError}
            onChange={this.handleChannelsChanged}
            onFieldDescriptionShow={onFieldDescriptionShow}
            onFieldDescriptionHide={onFieldDescriptionHide}
            expiredAnalyticsDataForInfluencer={getExpiredAnalyticsDataForInfluencer([], false)}
          />
          {this.renderAgeWarning()}
          <FormActions align="center">
            <ActionButton
              color="tertiary"
              onClick={this.handleCancel}
            >
              {__t('profile_creation_common.buttons.button_back')}
            </ActionButton>
            <ActionButton
              color="primary"
              type="submit"
            >
              {__t('profile_creation_common.buttons.button_continue')}
            </ActionButton>
          </FormActions>
        </Form>
      </section>
    );
  }
}

export default ProfileCreationStepChannels;
